export { default } from "./BaseChip.vue";
